export const getQueryParam = (
  key: string,
  queryString: string = window.location.search,
): string | undefined => {
  const rg = new RegExp(`(?:${key}=)(.*?)(?:$|&)`);
  const matches = queryString.match(rg);

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

export function capitalizeFirstLetter(val?: string) {
  if (val) {
    return val[0].toUpperCase() + val.slice(1).toLowerCase();
  } else {
    return val;
  }
}
